module.exports = __webpack_public_path__ + "img/141-azerbaijan.2f530702.svg";